var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2392 8.61436L11.3642 15.4894C11.2675 15.5859 11.1365 15.6402 10.9998 15.6402C10.8632 15.6402 10.7321 15.5859 10.6355 15.4894L3.76046 8.61436C3.66938 8.51662 3.61979 8.38733 3.62215 8.25375C3.62451 8.12017 3.67862 7.99272 3.77309 7.89825C3.86756 7.80378 3.99502 7.74966 4.1286 7.7473C4.26218 7.74495 4.39146 7.79453 4.48921 7.88561L10.9998 14.3954L17.5105 7.88561C17.6082 7.79453 17.7375 7.74495 17.8711 7.7473C18.0047 7.74966 18.1321 7.80378 18.2266 7.89825C18.321 7.99272 18.3752 8.12017 18.3775 8.25375C18.3799 8.38733 18.3303 8.51662 18.2392 8.61436Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.fa6d81a5b9d11f4ca2e5f17c4c85797b.svg";
export { ForwardRef as ReactComponent };